<template>
  <div>
    <div class="error input-error" v-if="errorMessage && errorMessage.length > 0">{{errorMessage}}</div>
    <div class="input text-input" @click="focusRef" :class="hasValue">
      <input type="text" :class="inputClass" ref="input" v-model="content" v-on:input="updateValue($event.target.value)"/>
      <span class="input--placeholder" v-if="placeholder">{{placeholder}}</span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'date-input',
  props: {
    error: Boolean,
    errorMessage: String,
    name: String,
    placeholder: String,
    icon: String,
    value: String,
  },
  data() {
    return {
      focused: false,
      content: this.value,
    };
  },
  watch: {
    value(o, v) {
      this.content = o === undefined ? '' : o;
    },
  },
  methods: {
    focusRef() {
      this.$refs.input.focus();
      this.$emit('input', this.content);
    },
    updateValue() {
      this.$emit('input', this.content);
    },
  },
  computed: {
    hasValue() {
      return (this.content !== '' && this.content !== undefined) ? 'has-value' : '';
    },
    inputClass() {
      const classes = ['form-control'];
      if (this.icon) {
        classes.push('icon', `${this.icon}-icon`);
      }
      if (this.error) {
        classes.push('errored');
      }
      return classes;
    },
  },
};
</script>

<style scoped>
  .input-error {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/date-input.vue